/**
 * 
 * key
 * 
 */


const key = 'bGF5b3V0X21hc3Rlcg=='

export default key 